import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const StatusPageShape = {
  api_key: Yup.string().label("API Key").min(32).max(256).required(),
  page: Yup.string().label("Page ID").min(12).max(12).required(),
  component: Yup.string().label("Component ID").max(12).optional(),
  metric: Yup.string().label("Metric ID").max(12).optional(),
};

export interface StatusPageInput {
  api_key: string;
  page: string;
  component?: string;
  metric?: string;
}

yupResolver<StatusPageInput>(Yup.object().shape(StatusPageShape));
